import { render, staticRenderFns } from "./expertCard.vue?vue&type=template&id=30c63a1e&scoped=true&"
import script from "./expertCard.vue?vue&type=script&lang=js&"
export * from "./expertCard.vue?vue&type=script&lang=js&"
import style0 from "./expertCard.vue?vue&type=style&index=0&id=30c63a1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c63a1e",
  null
  
)

export default component.exports